import { WorkProp } from '../pages/WorkUpgradePage/WorkUpgradePage';
import { Api } from './api';

export class WorkApi {
    private static readonly PATH = '/work';

    constructor(private readonly m_api: Api) {}

    public async getWork() {
        return this.m_api.get('/work');
    }

    public async convertEnergy() {
        return this.m_api.post('/work/convert-energy', {});
    }

    public async upgradeWork(workProp: WorkProp) {
        return this.m_api.post(`/work/upgrade`, { workProp });
    }
}